export default __webpack_public_path__ + "static/media/edward.1caa219f.png";